import(/* webpackMode: "eager" */ "/home/runner/work/play/play/src/app/games/(details)/[uid]/loading.tsx");
